import { Box } from '@material-ui/core';

const getImageEmptyData = (): JSX.Element => (
  <Box
    display="flex"
    justifyContent="center"
    alignItems="center"
    height="100%"
    data-testid="empty-image"
  >
    <img src="emptyMetricData.png" alt="emptyMetricData" />
  </Box>
);

export default getImageEmptyData;
